// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organizations-table thead th:last-child,
.organizations-table tbody td:last-child {
  min-width: 5.5rem;
  width: 5.5rem;
  text-align: center;
}

.organizations-table tbody td:last-child {
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Organizations/Organizations.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".organizations-table thead th:last-child,\r\n.organizations-table tbody td:last-child {\r\n  min-width: 5.5rem;\r\n  width: 5.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.organizations-table tbody td:last-child {\r\n  white-space: nowrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
